import { defineStore } from "pinia";
import { ref } from "vue";

export const useQuizStore = defineStore("quizStore", () => {
  /**
   * stage
   * {id, name, imagePath, tags}[]
   */
  const stage1 = ref([]);
  const stage2 = ref([]);
  return {
    stage1,
    stage2,
  };
});
